import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import { InvoiceOperationResult } from "../../entities/InvoiceEntity";

/**
 * Delete Posted Invoice Use Case
 * Deletes an invoice that has been posted to Zoho (removes payments in Zoho, then deletes the invoice, then soft-deletes locally)
 */
export class DeletePostedInvoiceUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(invoiceId: number): Promise<InvoiceOperationResult> {
    return await this.repository.deletePostedInvoice(invoiceId);
  }
}
